import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../elements/header/Header";
import Table from "../../elements/Table/Table";
import PayablesSideBar from "../../components/payables/PayablesSideBar";
import DataState from "../../elements/common/DataState/DataState";
import ERPDataTable from "../../elements/Table/ERPTable";
import commoncss from "../../css/common.module.css";

const Listing = () => {
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const { id: PayableID } = useParams();

  const handleFiltersApplied = (filters) => {
    setAppliedFilters(filters);
  };

  const handleNoDataFound = () => {
    setAppliedFilters([]);
  };

  useEffect(() => {
    if (showTable && tableType === null) {
      setTableType("excel");
    }
  }, [showTable, tableType]);

   return (
    <>
      <div style={{ display: "flex" }}>
        <PayablesSideBar activeTab={"Listing"} />
        <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
          <Header
            setShowDataState={setShowDataState}
            tableType={tableType}
            setTableType={setTableType}
            setShowTable={setShowTable}
            showAddRegisterModal={showAddRegisterModal}
            setShowAddRegisterModal={setShowAddRegisterModal}
            PayableID={PayableID}
            onFiltersApplied={handleFiltersApplied}
          />

          {showDataState && !showTable && <DataState  setShowAddRegisterModal={setShowAddRegisterModal}/>}
          {showTable && tableType === "excel" && (
            <Table
              PayableID={PayableID}
              filters={appliedFilters}
              onNoDataFound={handleNoDataFound}
            />
          )}
          {showTable && tableType === "erp" && <ERPDataTable />}
        </div>
      </div>
    </>
  );
};

export default Listing;